import React from 'react';
import { Form, Button } from '@blueprintnyc/bpnyc-common';
import EventGroupsPicker from '@/components/EventGroupsPicker';
import LinkPicker from 'components/LinkOmniPicker/LinkPicker';
import ImageUpload from 'components/ImageUpload';
import OmniPicker from '@/components/OmniPicker';
import config from 'config';

const MediaWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		handleChange,
		widgetProps,
		onUpdate,
		setOmniPicker,
		handlePickOmniItem,
		omniPicker,
		handlePickMedia,
		handleGroupChange,
		targetKeys,
	} = props;
	const { onPress } = widgetProps;
	const signedUrlEndpoint = `${config.baseUrl}/${event.client_id}/events/${event.id}/upload/media/signed_url`;

	return (
		<Form initialValues={widgetToUpdate.props} onChange={handleChange}>
			<div className="WidgetUpdateForm">
				<Form.Item label="Media Source" name="source">
					<ImageUpload endpoint={signedUrlEndpoint} imageObj={true} />
				</Form.Item>
				<h4 className="admin-form-item-label">Media Link</h4>
				<LinkPicker
					onClick={() => setOmniPicker({ open: true, mediaPicker: false, from: 'link' })}
					onPress={onPress}
					placeholderStr={'Select Link Target'}
					onConfirm={() => handlePickOmniItem({}, 'link')}
				/>
				<h4 className="admin-form-item-label">Group Permissions</h4>
				<div className="groups-picker">
					<EventGroupsPicker
						event={event}
						handleChange={handleGroupChange}
						targetKeys={targetKeys}
					/>
				</div>
			</div>
			<Button type="submit" style={{ marginTop: '15px' }} onClick={() => onUpdate(widgetProps)}>
				Submit
			</Button>
			<OmniPicker
				event={event}
				visible={omniPicker.open}
				onCancel={() => setOmniPicker({ open: false, mediaPicker: false, from: '' })}
				handlePickItem={handlePickOmniItem}
				handlePickMedia={handlePickMedia}
				mediaPicker={omniPicker.mediaPicker}
				onPress={onPress}
				from={omniPicker.from}
			/>
		</Form>
	);
};

export default MediaWidgetOptions;
